import React, { useEffect, useState, memo } from "react";
import ReactApexChart from "react-apexcharts";
import { calculateFibonacciRetracement } from "../service/utils";

//var retracements = []
function TradeChart(props) {
  const opt = { timeZone: "America/New_York", timeZoneName: "short" };
  const [chartToDisplay, setChartToDisplay] = useState([]);

  //console.log("Tradechart OHLC:", props.data)

  const ohlc = props.data.map(({ t, open, high, low, close }) => ({
    x: new Date(t).toLocaleString("en-US", opt),
    y: [parseFloat(open), parseFloat(high), parseFloat(low), parseFloat(close)],
  }));

  //console.log("Tradechart OHLC:", ohlc)

  const [retracements, setRetracements] = useState([]);

  useEffect(() => {
  const period = 30;
  if (ohlc.length > period) {
    const retracementLevels = calculateFibonacciRetracement(ohlc, period);
    //console.log("retracementLevels:", retracementLevels)
    const newRetracements = Object.values(retracementLevels);
    //console.log("FR-1:", newRetracements);
    //retracements = newRetracements
    setRetracements(newRetracements);
  }
}, [props.data])

  
  useEffect(() => {
    //Perform action when retracements change
    //console.log("Retracements changed:", retracements);
    const grid = {
      show: false}

    const modifiedAnnotations = {
      position: 'back' ,
      yaxis: retracements.map((level) => {
        //console.log("adding retracement:", level);
        return {
          y: level,
          borderColor: "#ccc",
          borderWidth: 1,
          label: {
            text: `${((level / ohlc[ohlc.length - 1].y[3]) * 100).toFixed(2)}%`,
            style: {
              background: "lightgrey",
              color: "#fff",
              opacity: ".3"
            },
            position: 'left',
          },
        };
      }),
    }
    const charts = []
    /* correct code
    setChartOptions({
      ...chartOptions,
      annotations:modifiedAnnotations,
      grid:grid})
      */

    /* old code
    charts.push(
      <div id="chart-candlestick">
      <ReactApexChart
        options={chartOptions}
        series={ohlcSeries.series}
        type="scatter"
        height={400}
      />
    </div>
    )
    setChartToDisplay(charts)*/
  }, [props.data, retracements]);

  /*
  useEffect(() => {
  
  }},[retracements])*/

  const min = Math.min(...ohlc.map((d) => d.y[2]));
  const max = Math.max(...ohlc.map((d) => d.y[1]));

  const rsi = props.data.map(({ t, rsi }) => ({
    x: new Date(t).toLocaleString("en-US", opt),
    y: parseFloat(rsi),
  }));

  const up = props.data.map(({ t, up }) => ({
    x: new Date(t).toLocaleString("en-US", opt),
    y: parseFloat(up).toFixed(2),
  }));

  //console.log("up:", up)

  const hold = props.data.map(({ t, hold }) => ({
    x: new Date(t).toLocaleString("en-US", opt),
    y: parseFloat(hold).toFixed(2),
  }));

  const down = props.data.map(({ t, down }) => ({
    x: new Date(t).toLocaleString("en-US", opt),
    y: parseFloat(down).toFixed(2),
  }));

  const pv = props.data.map(({ t, pv }) => ({
    x: new Date(t).toLocaleString("en-US", opt),
    y: parseFloat(pv).toFixed(2),
  }));

  const [chartOptions, setChartOptions] = useState({
    chart: {
      type: "scatter",
      height: 300,
      zoom: {
        enabled: true,
        type: "x",
      },
      animations: {
        enabled: false,
      },
    },
    /*
    annotations: {
      position: 'back' ,
      yaxis: retracements.map((level) => {
        //console.log("adding retracement:", level);
        return {
          y: level,
          borderColor: "#ccc",
          borderWidth: 1,
          label: {
            text: `support - ${((level / ohlc[ohlc.length - 1].y[3]) * 100).toFixed(2)}%`,
            style: {
              background: "#000",
              color: "#fff",
            },
            position: 'left',
          },
        };
      }),
    },*/
    /*
    annotations: {
      xaxis: [{ 
        x:ohlc.length > 30 ? new Date(ohlc[ohlc.length-30].x).getTime(): new Date(ohlc[ohlc.length-1].x).getTime(),
        borderColor: '#999',
        label: {
          text: 'Default Window',
          style: {
            color: '#fff',
            background: '#00E396'
          }
        }
      },
      {
        x: new Date(ohlc[ohlc.length-1].x).getTime(),
        borderColor: '#999',
      }
    ]

    },*/

    grid: {
      show: false,
      yaxis: {
        lines: {
          show: false,
        },
      },
    },

    plotOptions: {
      candlestick: {
        colors: {
          upward: "#1FCEFF47",
          downward: "#FFCC0047",
        },
      },
      scatter: {
        colors: ["#1fad45", "#c71423", "#1468c7"],
      },

      markers: {
        size: [0, 2],
        colors: ["#1fad45", "#c71423", "#1468c7"],
        shape: "square",
      },

      events: {
        zoomed: function (chartContext, { xaxis, yaxis }) {
          //console.log("zoom", yaxis);
          setChartOptions({
            ...chartOptions,
            yaxis: {
              min: yaxis[0].min,
              max: yaxis[0].max,
              lines: {
                show: false,
              },
            },
          });
        },
      },
    },
    title: {
      //text: "CandleStick Chart",
      align: "left",
    },
    grid: {
      show: true,
    },
    xaxis: {
      type: "datetime",
      scrollbar: {
        enabled: true,
        //window: 30, // default window size in days
        range:'last30'
      },
      labels: {
        formatter: function (val) {
          return new Date(val).toLocaleDateString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: false,
          });
        },
        //min: new Date(ohlc[ohlc.length - 30].x).getTime(),
        //max: new Date(ohlc[ohlc.length - 1].x).getTime(),
      },
      // Set the range of the x-axis to the last 30 items
      //min: new Date(ohlc[ohlc.length - 30].x).getTime(),
      //max: new Date(ohlc[ohlc.length - 1].x).getTime(),
    },
    yaxis: {
      tooltip: {
        enabled: true,
      },
      min: Math.min(...ohlc.map((d) => d.y[2])),
      max: Math.max(...ohlc.map((d) => d.y[1])),
    },
    labels:{
      formatter: (value) => { return value.foFixed(2) },
    }
  });

  const ohlcSeries = {
    series: [
      { name: "candlestick", type: "candlestick", data: ohlc },
      { name: "UP Trend", type: "scatter", data: up },
      //{ name: "hold", type: "scatter", data: hold },
      { name: "Predicted Target", type: "scatter", data: pv },
      { name: "DOWN Trend", type: "scatter", data: down },
    ],
  };

  const ohlcSeries1 = {
    series: [
      //{ name: "candlestick", type: "candlestick", data: ohlc },
      { name: "scatter", type: "scatter", data: hold },
    ],
  };
  //console.log("series1", ohlcSeries);

  useEffect(() => {
    setChartOptions({
      ...chartOptions,
      yaxis: {
        tooltip: {
          enabled: true,
        },
        min: Math.min(...ohlc.map((d) => d.y[2])),
        max: Math.max(...ohlc.map((d) => d.y[1])),
      },
    });
  }, [props.data]);

  return (
    <div
      className="rounded mb-0"
      style={{
        height: "400px",
      }}
    >
            <div id="chart-candlestick">
      <ReactApexChart
        options={chartOptions}
        series={ohlcSeries.series}
        type="scatter"
        height={400}
      />
    </div>
    </div>
  );
}

export default memo(TradeChart);
